import React from 'react'
import Table from '../../components/common/Table'
import { FellowDTO } from '../../services/apiClient'
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime'
import { renderBooleanBadge } from '../../utils/displayUtils'

interface FellowTableProps {
    data: FellowDTO[];
    handleEdit: (row: FellowDTO) => void;
    handleDelete: (row: FellowDTO) => void;
    currentPage: number;
    totalPages: number;
    setCurrentPage: (page: number) => void;
    pageSize: number;
    setPageSize: (size: number) => void;
    isLoading: boolean;
}

const FellowTable: React.FC<FellowTableProps> = ({
    data,
    handleEdit,
    handleDelete,
    currentPage,
    totalPages,
    setCurrentPage,
    pageSize,
    setPageSize,
    isLoading,
}) => {
    return (
        <Table
            columns={[

                {
                    label: "Name",
                    key: "name",
                },
                {
                    label: "Company Name",
                    key: "companyName",
                },
                {
                    label: "Email",
                    key: "email",
                },
                {
                    label: "Phone Number",
                    key: "phoneNumber",
                },
                {
                    label: "Province",
                    key: "province",
                    render: (row: FellowDTO) => <span>{row.province?.title}</span>,
                },
                {
                    label: "Website",
                    key: "website",
                    render: (row: FellowDTO) => <a href={row.website} target="_blank">{row.website}</a>,
                },
                {
                    label: "Motivations",
                    key: "canWriteEndorsementMotivations",
                    render: (row: FellowDTO) => renderBooleanBadge(row.canWriteEndorsementMotivations ?? false),
                },
                {
                    label: "Active",
                    key: "isActive",
                    render: (row: FellowDTO) => renderBooleanBadge(row.isActive ?? false),
                },
                {
                    label: "Added",
                    key: "createdUtc",
                    format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
                },
            ]}
            data={data}
            actions={{
                onEdit: handleEdit,
                onDelete: handleDelete,
            }}
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
            pageSize={pageSize}
            onPageSizeChange={setPageSize}
            isLoading={isLoading}
        />
    );
};

export default FellowTable;
